<gd-choose-template-modal
  [items]="items$ | async"
  [searchParams]="searchParams$ | async"
  [isLoading]="isLoading$ | async"
  (templateToStoreAdd)="addTemplateToStore($event)"
  (searchParamsChange)="changeSearchParams($event)"
  (templateCreate)="createTemplate()"
  (scrollDown)="scrollDown()"
></gd-choose-template-modal>
